import { defineStore } from "pinia";


const useCreditData = defineStore({
    id: "creditData",
    state: () => {
        return {
            isShowCreditDialog: false,
            isChangeTab: true
        }
    },
    actions: {
        changeCreditSialogDate(val) {
            this.isShowCreditDialog = val
        },
        changeTabState() {
            this.isChangeTab = false
        }
    }
})

export default useCreditData;